import type {
  ControllerPlacementCandidateInfo,
  PositionAtControllerPlacement,
} from "building-types/electrical/candidate";
import type { ElectricalLayoutType } from "building-types/electrical/electricalLayoutTypesEnum";
import type { ControllerType } from "building-types/electrical/electricalTypesEnum";
import type { ControllerPosition } from "building-types/electrical/generatedElectricalTypes";
import type { Vec2 } from "geom/vec2";
import { vec2Copy } from "geom/vec2";

export function commitControllerSelection(
  candidateInfo: ControllerPlacementCandidateInfo | null | undefined,
  electricalLayoutType: ElectricalLayoutType,
  controllerType: ControllerType,
  connectedLoadApproximatePosition: Vec2 | undefined,
): ControllerPosition | null {
  if (candidateInfo === null || candidateInfo === undefined) {
    return null;
  }

  const { candidate, subControllerPositions } = candidateInfo;
  const { position: preliminaryPosition } = candidate;

  // places a reference in both controller and loads so that adjustments between the different controllers
  //   at the panel can be shared.

  const sharedPosition: Vec2 = vec2Copy(preliminaryPosition);

  const subControllerPosition: PositionAtControllerPlacement = {
    loadApproximatePosition: connectedLoadApproximatePosition ? vec2Copy(connectedLoadApproximatePosition) : undefined,
    electricalLayoutType,
    subControllerPosition: sharedPosition,
  };

  subControllerPositions.push(subControllerPosition);

  return { position: sharedPosition, normal: candidate.normal, controllerType };
}
